<template>
  <lu-vbox lu-flex class="app-container" >

    <lu-item>
    <PageHeader :title='$t("Reports")' :hasReload='true' :hasDownLoad='true' @reload='reload'/>
    </lu-item>

    <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px; margin-top:15px;'>
      <el-table
         class='table'
         :data="reportConfigList"
         fit
         striped
         style="width: 100%;"
         :default-sort = "{prop: 'brokerName', order: 'ascending'}"
         :row-class-name="tableRowClassName"
      >

          <el-table-column :label="$t('Broker')" sortable prop='brokerName' align="left" >
            <template slot-scope="scope">
              <span>{{ scope.row.brokerName }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('Description')" sortable prop='description' align="left" >
            <template slot-scope="scope">
              <span>{{ scope.row.description }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="$t('Active')"     sortable prop="active"      >
            <template slot-scope="scope">
              <el-checkbox :disabled="!scope.row.isEdit" v-model="scope.row.active" />
            </template>
          </el-table-column>

          <el-table-column :label="$t('E-mail List')" sortable prop='emailTo' align="left" :show-overflow-tooltip="true" >
            <template slot-scope="scope">
              <span v-if='!scope.row.isEdit'>{{ scope.row.emailTo }}</span>
              <el-input v-if='scope.row.isEdit' type="textarea" autosize clearable :placeholder="$t('E-mail list')" v-model="scope.row.emailTo" maxlength='250' />
            </template>
          </el-table-column>

          <el-table-column :label="$t('Actions')" align="center" width="150">
            <template slot-scope="scope">
              <lu-hbox lsu-hcenter slu-vcenter cslass='pad-in-5'>
                <el-button v-if='!scope.row.isEdit' class="icon" size="mini" icon='el-icon-edit success' @click='handleEdit(scope.row)' />
                <el-button v-if='scope.row.isEdit' class="icon" size="mini" :icon="scope.row.isSave ? 'el-icon-loading positive'  : 'el-icon-check positive'" @click.stop='saveItem(scope.row)' />
                <el-button v-if='scope.row.isEdit' class="icon" size="mini" icon='el-icon-close' @click.stop='cancelItemChanges(scope.row)' />
              </lu-hbox>
            </template>
          </el-table-column>

      </el-table>
    </lu-scroll-area>
  </lu-vbox>
</template>

<script>
import BaseController from '@/controllers/BaseController'
import { LuVbox, LuHbox, LuItem, LuScrollArea } from 'lusis-ui'
import PageHeader from '@/components/PageHeader'
import { mapGetters } from 'vuex'

export default {
  extends: BaseController,
  name: 'reports',
  components: { LuVbox, LuHbox, LuItem, LuScrollArea, PageHeader },
  data () {
    return {
      reportConfigList: []
    }
  },
  created () {
    this.getReportConfigList()
  },
  mounted: function () {
  },
  computed: {
    ...mapGetters([ 'theme' ]),
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    },
  },
  methods: {
    pageControllerName () {
      return 'reports'
    },
    reload () {
      this.getReportConfigList()
    },
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'odd-row';
      } else {
        return 'even-row';
      }
    },
    getReportConfigList () {
      return this.$tango.getReportConfigList().then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : getReportConfigList')
        } else {

          this.reportConfigList = []
          if (rep.exportList && rep.exportList.length) {
            this.reportConfigList = rep.exportList.map(item => {
              item.active = item.active === 1 ? true : false
              item.originActive = item.active
              item.originEmailTo = item.emailTo
              item.isEdit = false
              item.isSave = false
              return item
            })
          }
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    updateReportConfig: function (data) {
      this.$nextTick().then(() => {
        data.isSave = true

        let cond = {
          brokerId: data.brokerId,
          description: data.description,
          active: data.active ? 1 : 0,
          emailTo: data.emailTo
        }

        this.$tango.updateReportConfig(cond).then(rep => {
          if (rep.resultCode !== 0) {
            throw new Error('ERROR : Report Config')
          } else {
            this.$message({
              message: 'Report config has been changed successfully',
              type: 'success'
            })

            //update flags + origin
            data.isSave = false
            data.isEdit = false
            data.originActive = data.active
            data.originEmailTo = data.emailTo
          }
          }).catch(err => {
            // eslint-disable-next-line no-console
            console.log(err)
          })
      })
    },
    handleEdit(row) {
      row.isEdit = true
    },
    saveItem(row) {
      if (!this.validateRowEmailList(row)) {
        this.$message({
          message: this.$t('Invalid email address'),
          type: 'error'
        })
        return
      }
      this.updateReportConfig(row)
    },
    cancelItemChanges(row) {
      row.active = row.originActive
      row.emailTo = row.originEmailTo
      row.isEdit = false
    },
    validateRowEmailList(row) {
      var flag = true
      if (row.emailTo!=="") {
        var emailList = row.emailTo.split(',');
        for (var i = 0; i < emailList.length; i++) {
          if (!this.validateEmail(emailList[i])) {
            flag = false
            break
          }
        }
      }
      return flag
    },
    validateEmail(email) {
        // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
  }
}
</script>

<style>

</style>